// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

const restrictedPostcodes = appConfig.homeEmergencyRestrictedPostcodesAPIMapping;

function getPostDistrict(postcode) {
    const postcodeDistrict = postcode.match(/^[A-Z0-9]{3}([A-Z0-9](?=\s*[A-Z0-9]{3}|$))?/); // remove white spaces
    if (postcodeDistrict) {
        return postcodeDistrict[0];
    }
    return '';
}

function isHomeEmergencyAvailable(postcode) {
    if (!postcode) return false;
    const uppercasePostcode = postcode.toUpperCase();

    const postDistrict = getPostDistrict(uppercasePostcode);

    return restrictedPostcodes.restrictedPostDistricts.every((restrictedArea) => {
        return postDistrict !== restrictedArea.toUpperCase();
    });
}

export default {
    isHomeEmergencyAvailable
};
